<template>
  <div></div>
</template>
<script>
import auth from "@/services/auth/authService";
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";
import encryption from "@/services/crypto/encryptionService";

export default {
  mounted: function() {
    let settings;

    if (this.$route.query.q) {
      settings = encryption.decrypt(this.$route.query.q);
      sharedoSettings.set(settings);
    }

    settings = sharedoSettings.get();
    auth.redirectToSharedoLogin();
  },
};
</script>
